<template>
  <v-card>
    <v-card-title>
      <v-title>
        <span class="headline">Edit Details</span>
      </v-title>
    </v-card-title>
    <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <vonex-text
              ref="firstName"
              v-model="extension.softPhoneDetails.firstName"
              :options="fieldConditions"
              hide-details
              label="First Name:"
              name="firstName"
              :rule="`required`"
            ></vonex-text>
            <!-- <v-text-field
            label="First Name:"
            name="firstName"
            v-model="extension.softPhoneDetails.firstName"
            v-validate="'required'"
            :error-messages="errors.collect('firstName')"
          /> -->
          </v-flex>
          <v-flex xs6>
            <vonex-text
              ref="lastName"
              v-model="extension.softPhoneDetails.lastName"
              :options="fieldConditions"
              hide-details
              :rule="`required`"
              label="Last Name:"
              name="lastName"
            ></vonex-text>
            <!-- <v-text-field
            label="Last Name:"
            name="lastName"
            v-model="extension.softPhoneDetails.lastName"
            v-validate="'required'"
            :error-messages="errors.collect('lastName')"
          /> -->
          </v-flex>
          <v-flex xs12>
            <vonex-text
              ref="email"
              v-model="extension.softPhoneDetails.email"
              :options="fieldConditions"
              label="Email:"
              name="email"
              hide-details
              :rule="`required|email`"
            ></vonex-text>
            <!-- <v-text-field
            label="Email:"
            name="email"
            v-model="extension.softPhoneDetails.email"
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
          /> -->
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" @click.native="clear()">Delete</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="invalid" @click.native="save()">
          Save
        </v-btn>
        <v-btn color="light-grey" @click.native="close()">Cancel</v-btn>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { SoftPhoneDetails } from '@/models/SoftPhoneDetails';
export default {
  name: 'SoftPhone',
  props: {
    extension: Object,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    clear() {
      let vm = this;
      vm.extension.softPhoneDetails = new SoftPhoneDetails();
      vm.extension.softPhone = false;
      this.$emit('DialogStatus', vm.extension);
    },
    close() {
      this.$emit('DialogStatus', null);
    },
    save() {
      let vm = this;
      vm.$refs.observer.validate().then((result) => {
        if (result) vm.$emit('DialogStatus', vm.extension);
      });
    },
  },
};
</script>

<style></style>
